export default {
    aiLimit: {
        account: 'The monthly AI limit is used up. It renews on {date}.',
        app: 'AI is temporarily unavailable. It will be back on {date}.',
    },
    actions: {
        cancel: 'Cancel',
        delete: 'Delete',
        save: 'Save',
        saving: 'Saving…',
        add: 'Add',
        edit: 'Edit',
        close: 'Close',
        back: 'Back',
        next: 'Next',
        done: 'Done',
        retry: 'Try again',
        search: 'Search',
        clear: 'Clear',
        ok: 'OK',
        yes: 'Yes',
        no: 'No',
    },
    states: {
        loading: 'Loading…',
        saved: 'Saved.',
        loadFailed: 'Could not load the data.',
        fetchFailed: 'Could not fetch the data.',
    },
    confirm: {
        title: 'Delete?',
        message: 'This cannot be undone.',
        deleting: 'Deleting…',
        undoable: 'You can still undo it for a moment.',
    },
    confirmAsk: {
        note: 'Delete note?',
        noteCategory: 'Delete category?',
        noteCategoryNotes: 'One note will be left without a category. You can still undo it for a moment. | {n} notes will be left without a category. You can still undo it for a moment.',
        project: 'Delete project?',
        projectTasks: 'Its task will be deleted too. You can still undo it for a moment. | Its {n} tasks will be deleted too. You can still undo it for a moment.',
        task: 'Delete task?',
        section: 'Delete section?',
        sectionTasks: 'Its task will move to tasks without a section. | Its {n} tasks will move to tasks without a section.',
        template: 'Delete template?',
        group: 'Delete group?',
        groupPeople: 'One person will be left without a group. You can still undo it for a moment. | {n} people will be left without a group. You can still undo it for a moment.',
        person: 'Delete person?',
        personData: 'Along with important dates, gift ideas and contact history. You can still undo it for a moment.',
        date: 'Delete important date?',
        gift: 'Delete gift idea?',
        contact: 'Delete contact?',
        pet: 'Delete pet?',
        petData: 'Along with care tasks, weight measurements and documents. You can still undo it for a moment.',
        weight: 'Delete weight measurement?',
        device: 'Delete device?',
        deviceData: 'Along with care tasks, mileage and documents. You can still undo it for a moment.',
        mileage: 'Delete mileage entry?',
        care: 'Delete care task?',
        careLogs: 'Its one completion in the history will be deleted too. You can still undo it for a moment. | Its {n} completions in the history will be deleted too. You can still undo it for a moment.',
        careLog: 'Delete completion?',
        habit: 'Delete the habit?',
        habitData: 'Along with its whole check-off history and streak. If you only want a break, archive it instead.',
        medication: 'Delete the medication?',
        medicationData: 'Along with the history of taken and skipped doses. If the course is over, you can archive it instead.',
        document: 'Delete document?',
        workoutType: 'Delete workout type?',
        targetWeight: 'Remove target weight?',
        variant: 'Delete variant?',
        attachment: 'Delete attachment?',
        overpayment: 'Undo overpayment?',
        overpaymentMessage: 'The overpayment will disappear from the history and the loan will be recalculated.',
        undoRecord: 'Delete this {what}?',
        assistantRecord: 'Delete the created entry?',
        basketItem: 'Remove from the list?',
        setItem: 'Remove from the set?',
        cooking: 'Delete batch cooking?',
        googleLogin: 'Disconnect Google sign-in?',
        googleLoginMessage: 'You will still sign in with your email and password.',
    },
    select: {
        placeholder: 'Choose',
        search: 'Search…',
        noMatch: 'Nothing matches.',
    },
    sectionInfo: {
        button: 'What’s this?',
        ariaLabel: 'What is this: {title}',
    },
    firstSteps: {
        cardHeading: 'GETTING STARTED · {done} OF {total}',
        hide: 'Hide',
        all: 'All',
        title: 'Getting started',
        intro: 'Add your first things — for each one we explain what it is and what it’s for. Tasks tick themselves off.',
        progress: '{done} of {total}',
        notApplicable: 'not relevant',
        why: 'Why?',
        first: 'First: {task}.',
        addMore: 'Add more',
        skip: 'Not for me',
        unskip: 'It applies after all',
        showOnHome: 'Show on the home page',
        alsoUnderHelp: 'The list is also under “Help” in the header.',
        doneTask: 'Done: {task}',
        nextTask: 'Next: {task}',
        allDone: 'You’ve finished getting started — all set.',
        list: 'List',
    },
    tourButton: {
        help: 'Help',
        guide: 'Guide',
        guideHint: 'What’s where — starting from this tab',
        firstSteps: 'Getting started',
        firstStepsHint: 'Add your first things and find out what they’re for',
        label: {
            forma: 'Help with Fitness',
            portfel: 'Help with Wallet',
            koszyk: 'Help with Groceries',
            planer: 'Help with Planner',
            miejsca: 'Help with Places',
            jedzenie: 'Help with Food',
            assistant: 'Help with the assistant',
            notatnik: 'Help with Notes',
            projekty: 'Help with Projects',
            ludzie: 'Help with People',
            zwierzeta: 'Help with Pets',
            sprzety: 'Help with Devices',
            nawyki: 'Help with Habits',
            leki: 'Help with Medications',
        },
    },
    tour: {
        gotIt: 'Got it',
        progress: '{current} of {total}',
        next: 'Next',
        prev: 'Back',
        done: 'Done',
    },
    errors: {
        saveRetry: 'Could not save. Please try again.',
        deleteFailed: 'Could not delete.',
    },
    date: {
        prevMonth: 'Previous month',
        nextMonth: 'Next month',
        openTasks: 'Unfinished tasks: {n}',
        openTasksDay: '{day}, unfinished tasks: {n}',
        weekdaysMin: {
            mon: 'M',
            tue: 'T',
            wed: 'W',
            thu: 'T',
            fri: 'F',
            sat: 'S',
            sun: 'S',
        },
        choose: 'Choose…',
        today: 'Today',
        yesterday: 'Yesterday',
        tomorrow: 'Tomorrow',
        now: 'Now',
        hour: 'Time',
        weekdaysShort: {
            mon: 'Mo',
            tue: 'Tu',
            wed: 'We',
            thu: 'Th',
            fri: 'Fr',
            sat: 'Sa',
            sun: 'Su',
        },
    },
    amount: {
        portionMode: 'You are entering portions (1 {portion} = {weight} g) — click to enter grams',
        gramMode: 'You are entering grams — click to enter portions (1 {portion} = {weight} g)',
        unitToggle: 'Unit: {unit}. Switch',
    },
    barcode: {
        title: 'Scan code',
        hint: 'Point the camera at the product’s barcode.',
        noPermission: 'No camera permission. Type the code in by hand or change the permissions in your browser.',
        cameraFailed: 'Couldn’t start the camera. Type the code in by hand.',
        manual: 'Or type the code in by hand',
        placeholder: 'e.g. 5901234123457',
    },
    record: {
        editPrefix: 'Edit',
        deleteNamed: 'Delete {name}?',
        required: 'This field is required',
        scanFill: 'Scan a barcode and fill in the fields',
        scanProduct: 'Scan the product’s barcode',
        shrink: 'Shrink window',
        expand: 'Enlarge window',
        tabError: 'Error in this tab',
        searchProduct: 'Search products',
        timePlaceholder: 'e.g. 9:30',
        codeNotInOff: 'Code {code} isn’t in Open Food Facts — enter the product by hand.',
        codeNotInCatalogue: 'Code {code} isn’t in the product catalogue.',
        codeCheckFailed: 'Couldn’t check the code. Please try again.',
        checkingCode: 'Checking the code…',
        offSearch: 'Search by name in Open Food Facts',
        searching: 'Searching…',
        offNotFound: 'Couldn’t find “{query}” — fill in the details by hand.',
        offFailed: 'Couldn’t connect to Open Food Facts.',
        offFilled: 'Details filled in — check them and add the price.',
        assistLabel: 'Fill in with AI',
        askingAi: 'Asking AI…',
        assistEmpty: 'Couldn’t estimate anything.',
        assistDone: 'Details filled in — check them before saving.',
        assistFailed: 'Couldn’t fill in the details.',
    },
    time: {
        now: 'Now · {time}',
        formatHint: 'e.g. 9:30, 930, 21',
    },
};
